module.exports = __webpack_public_path__ + "img/img-7.87904172.svg";